var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.booking && _vm.action && _vm.action.type)?_c('p',[_c('DeadlineCountdownTimer',{attrs:{"deadline":_vm.action.deadline,"title":("booking.details.timeline.actions." + (_vm.action.type.toLowerCase()))}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }